export default "__VITE_ASSET__Cgq82JVl__"